import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ActionButtonsProps {
  onHit: () => void
  onStand: () => void
  onDouble: () => void
  canDouble: boolean
  canSplit: boolean
  disabled: boolean
}

export function ActionButtons({
  onHit,
  onStand,
  onDouble,
  canDouble,
  canSplit,
  disabled,
}: ActionButtonsProps) {
  const buttonVariants = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
  }

  return (
    <div className="flex gap-3 justify-center flex-wrap">
      <motion.div whileHover="hover" whileTap="tap" variants={buttonVariants}>
        <Button
          onClick={onHit}
          disabled={disabled}
          className={cn(
            'px-8 py-3 font-cinzel text-lg',
            'bg-gradient-to-b from-green-600 to-green-800',
            'hover:from-green-500 hover:to-green-700',
            'border-2 border-green-400',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
        >
          HIT
        </Button>
      </motion.div>

      <motion.div whileHover="hover" whileTap="tap" variants={buttonVariants}>
        <Button
          onClick={onStand}
          disabled={disabled}
          className={cn(
            'px-8 py-3 font-cinzel text-lg',
            'bg-gradient-to-b from-red-600 to-red-800',
            'hover:from-red-500 hover:to-red-700',
            'border-2 border-red-400',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
        >
          STAND
        </Button>
      </motion.div>

      <motion.div whileHover="hover" whileTap="tap" variants={buttonVariants}>
        <Button
          onClick={onDouble}
          disabled={disabled || !canDouble}
          className={cn(
            'px-8 py-3 font-cinzel text-lg',
            'bg-gradient-to-b from-casino-gold-dark to-casino-gold',
            'hover:from-casino-gold hover:to-casino-gold-light',
            'text-casino-black border-2 border-casino-gold-light',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
        >
          DOUBLE
        </Button>
      </motion.div>

      {canSplit && (
        <motion.div
          whileHover="hover"
          whileTap="tap"
          variants={buttonVariants}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <Button
            disabled={disabled}
            className={cn(
              'px-8 py-3 font-cinzel text-lg',
              'bg-gradient-to-b from-purple-600 to-purple-800',
              'hover:from-purple-500 hover:to-purple-700',
              'border-2 border-purple-400',
              'disabled:opacity-50 disabled:cursor-not-allowed'
            )}
          >
            SPLIT
          </Button>
        </motion.div>
      )}
    </div>
  )
}
